const analytics = {

  /**
   * Pushes data to GTM datalayer
   *
   * @param {Object} data - Data to send
   */
  push(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  },

  /**
   * Pushes data added in Stage scriptlets to GTM datalayer.
   * Add data to window.UNICEF.dataLayer in Stage
   * if it needs to be sent after cookie consent is submitted.
   */
  triggerDelayedDataLayer() {
    window.UNICEF.dataLayer.forEach(item => this.push(item));
    window.UNICEF.dataLayer.splice(0, window.UNICEF.dataLayer.length);
  }
};

export default analytics;
